import scrollIntoItem from './scrollIntoItem';

export default (val, opts = {}) => {
  const { event } = opts;
  event && scrollIntoItem(event);
};
